(function (window) {
  function extend(target, source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key];
      }
    }
    return target;
  }

  function ProxyLink(elements, options) {
    elements.forEach(function (element) {
      var settings = extend({
        excludes: []
      }, options);

      element.addEventListener('click', function (e) {
        if (settings.onBeforeUnload && typeof settings.onBeforeUnload === 'function') {
          settings.onBeforeUnload(element);
        }

        var link = element.getAttribute('data-link-proxy');

        for (var i = 0; i < settings.excludes.length; i++) {
          var excludedClass = settings.excludes[i].replace('.', '');

          if (e.target.classList.contains(excludedClass) || e.target.closest(settings.excludes[i])) {
            e.stopPropagation();
            return;
          }
        }

        e.preventDefault();
        window.location.href = link;
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
        var elements = document.querySelectorAll('[data-link-proxy]');
        ProxyLink(Array.from(elements), {
          excludes: [
            '.slick-dots',
            '.product-tile__variants',
            '.swym-add-to-wishlist-view-product',
            '.product-tile__hover--quick-buy--button',
            '.product-tile__hover--quick-buy__form__option__values'
          ]
        });

        window.addEventListener("refreshLinkProxy", (e) => {
              var elements = document.querySelectorAll('[data-link-proxy]');
              ProxyLink(Array.from(elements), {
                    excludes: [
                      '.slick-dots',
                      '.product-tile__variants',
                      '.swym-add-to-wishlist-view-product',
                      '.product-tile__hover--quick-buy--button',
                      '.product-tile__hover--quick-buy__form__option__values'
                    ]
      });
    });
  });

})(window);
